import { useState, useEffect } from 'react';
// next
import { useRouter } from 'next/router';
// @mui
import {
  TableRow,
  TableCell,
  Typography,
  Stack,
  Button,
} from '@mui/material';
// components
import Avatar from '../../components/Avatar';
import Label from '../../components/Label';
import Iconify from '../../components/Iconify';
import SvgIconStyle from '../../components/SvgIconStyle';
// hooks
import useAuth from '../../hooks/useAuth';
// utils
import { FliersDetailDrawer } from './';
import Image from '../../components/Image';
// routes
import { PATH_SCOUT } from '../../routes/paths';

// ----------------------------------------------------------------------

const positionLabel = {
  "developer": "개발자",
  "designer": "디자이너",
  "marketer": "마케터",
  "engineer": "하드웨어 엔지니어",
  "product-manager": "설계 / 기획 / 관리",
  "data-analysis": "데이터분석",
  "finance": "재무 • IR/투자 전문가",
  "operator": "CS • 오퍼레이터",
};

const statusLabel = {
  "wait": "진행전",
  "dio-will-offer": "DIO가 제안 예정",
  "offer-to-crew": "커피챗 제안 보냄",
  "offer-to-company": "커피챗 일정 확정하기",
  "other-time-requested": "다른 일정 요청함",
  "crew-decline": "크루의 커피챗 거절",
  "company-decline": "중단",
  "meeting-selected": "커피챗 일정 선택함",
  "meeting-confirmed": "커피챗 일정 확정",
  "meeting-done": "파트타임 제안 가능",
};

export default function CoffeeChatTableRow({ row, reload }) {
  const { user } = useAuth();
  const { query, push } = useRouter();
  const [isOpenFliersDetailDialog, setIsOpenFliersDetailDialog] = useState(false);

  const greyStatus = row.coffee_chat_status === "wait" || row.coffee_chat_status === "crew-decline" || row.coffee_chat_status === "company-decline";

  const {
    crew,
    coffee_chat_status,
    coffee_chat_by_dio,
  } = row;

  const {
    nickname,
    position,
    randomhash,
  } = crew;

  useEffect(() => {
    if (query && query.cid && query.cid == row?.id) {
      setIsOpenFliersDetailDialog(true);
      push(PATH_SCOUT.manage, undefined, { shallow: true });
    }
  }, [query]);

  return (
    <TableRow
      sx={{
        "&:hover": {
          backgroundColor: "grey.100",
          "& .detailbtn": {
            opacity: 1,
          }
        },
      }}
    >
      <TableCell align="left">
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="left" sx={{ position: "relative" }}>
          <Avatar
            src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${randomhash || '5'}.png`}
            alt={nickname}
            sx={{
              width: 40,
              height: 40,
            }}
          />
          <Typography variant="subtitle1" noWrap>
            {nickname}
          </Typography>
          <Typography variant="body2" color="text.secondary" noWrap>
            {positionLabel?.[position]}
          </Typography>

          {/* drawer btn */}
          <Stack
            className='detailbtn'
            direction="row"
            justifyContent={"flex-end"}
            sx={{
              width: "calc(100% - 32px)",
              position: "absolute",
              right: 2,
              opacity: 0,
            }}
          >
            <Button
              sx={{
                backgroundColor: "white",
                "&:hover": {
                  backgroundColor: "grey.300"
                }
              }}
              variant="outlined"
              size="small"
              color="inherit"
              endIcon={<Iconify icon="ic:chevron-right" sx={{ ml: -0.5 }} />}
              onClick={() => setIsOpenFliersDetailDialog(true)}
            >
              자세히보기
            </Button>
          </Stack>
        </Stack>
      </TableCell>

      <TableCell align="left">
        <Label
          color={greyStatus ? "default" : "info"}
          variant={greyStatus ? "ghost" : "filled"}
        >
          {statusLabel?.[coffee_chat_status]}
        </Label>
      </TableCell>

      <TableCell align="left">
        <Stack direction="row" alignItems="center" spacing={.5}>
          {coffee_chat_by_dio ? (
            <Image src="/icons/ic_dio.png" sx={{ width: 20, height: 20 }} />
          ) : (
            <SvgIconStyle src="/icons/icon-user-mono.svg" sx={{ width: 20, height: 20, color: "#8B95A1" }} />
          )}
          <Typography variant="body2">
            {coffee_chat_by_dio ? "DIO 매니저" : user?.username}
          </Typography>
        </Stack>
      </TableCell>

      <FliersDetailDrawer
        isOpen={isOpenFliersDetailDialog}
        closeDrawer={() => setIsOpenFliersDetailDialog(false)}
        coffeeChat={row}
        reload={reload}
        reloadScout={() => {}}
      />
    </TableRow>
  )
}